import { Box } from "@mui/material";
import React, { memo } from "react";
import { useSelector } from "react-redux";
import Checkbox from "../../../../../../../Components/CheckBox/Checkbox";
import { nodeInputStyles } from "../../GeneralNodeStyles";

const EmbeddingModel = memo(({ data, embedding, setEmbedding }) => {
  const { setBotData, nodeId } = data;
  const organization = useSelector((state) => state.organization);

  const handleEmbeddingChange = (event, type) => {
    const embedding_model = { ...embedding };
    embedding_model[type] = event.target.checked;

    if (!Object.values(embedding_model).some((value) => value)) {
      embedding_model["text-embedding-ada-002"] = true; // Assuming "text-embedding-ada-002" is the first checkbox
    }
    setEmbedding({ ...embedding_model });
    localStorage.setItem(
      `embedding_${nodeId}`,
      JSON.stringify(embedding_model)
    );

    setBotData((prevData) => ({
      ...prevData,
      workflow: {
        ...prevData.workflow,
        [`${nodeId}`]: {
          ...prevData.workflow[`${nodeId}`],
          embedding_model: embedding_model,
        },
      },
    }));
  };

  return (
    <Box
      sx={{
        ...nodeInputStyles,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Checkbox
        label="text-embedding-ada-002"
        onChange={(event) =>
          handleEmbeddingChange(event, "text-embedding-ada-002")
        }
        checked={embedding?.["text-embedding-ada-002"]}
      />
      <Checkbox
        label="text-embedding-3-small"
        onChange={(event) =>
          handleEmbeddingChange(event, "text-embedding-3-small")
        }
        checked={embedding?.["text-embedding-3-small"]}
      />
      <Checkbox
        label="text-embedding-3-large"
        onChange={(event) =>
          handleEmbeddingChange(event, "text-embedding-3-large")
        }
        checked={embedding?.["text-embedding-3-large"]}
        disabled={organization?.organization?.subscription === "starter"}
        tooltipText={
          organization?.organization?.subscription === "starter" &&
          "You need Pro subscription to access this feature."
        }
        tooltipPlacement="left"
      />
      <Checkbox
        label="Voyage Law 2"
        onChange={(event) => handleEmbeddingChange(event, "voyage-law-2")}
        checked={embedding?.["voyage-law-2"]}
        disabled={organization?.organization?.subscription === "starter"}
        tooltipText={
          organization?.organization?.subscription === "starter" &&
          "You need Pro subscription to access this feature."
        }
        tooltipPlacement="left"
      />

      <Checkbox
        label="Voyage Finance 2"
        onChange={(event) => handleEmbeddingChange(event, "voyage-finance-2")}
        checked={embedding?.["voyage-finance-2"]}
        disabled={organization?.organization?.subscription === "starter"}
        tooltipText={
          organization?.organization?.subscription === "starter" &&
          "You need Pro subscription to access this feature."
        }
        tooltipPlacement="left"
      />

      <Checkbox
        label="Voyage Code 3"
        onChange={(event) => handleEmbeddingChange(event, "voyage-code-3")}
        checked={embedding?.["voyage-code-3"]}
        disabled={organization?.organization?.subscription === "starter"}
        tooltipText={
          organization?.organization?.subscription === "starter" &&
          "You need Pro subscription to access this feature."
        }
        tooltipPlacement="left"
      />

      <Checkbox
        label="Voyage 3.5"
        onChange={(event) => handleEmbeddingChange(event, "voyage-3.5")}
        checked={embedding?.["voyage-3.5"]}
        disabled={organization?.organization?.subscription === "starter"}
        tooltipText={
          organization?.organization?.subscription === "starter" &&
          "You need Pro subscription to access this feature."
        }
        tooltipPlacement="left"
      />

      <Checkbox
        label="Embed 4.0"
        onChange={(event) => handleEmbeddingChange(event, "embed-v4.0")}
        checked={embedding?.["embed-v4.0"]}
        disabled={organization?.organization?.subscription === "starter"}
        tooltipText={
          organization?.organization?.subscription === "starter" &&
          "You need Pro subscription to access this feature."
        }
        tooltipPlacement="left"
      />

      <Checkbox
        label="Fine tuned model"
        onChange={(event) => handleEmbeddingChange(event, "fine-tuned")}
        checked={embedding?.["fine-tuned"]}
        disabled={true}
        tooltipText={"You need Enterprise subscription to access this feature."}
        tooltipPlacement="left"
      />
    </Box>
  );
});

export default EmbeddingModel;
